<template lang="pug">
.cms-card.d-inline-block.px-2(:style="{ width: width || '350px' }")
  .wrapper.d-flex.flex-column.shadow.position-relative
    .image-wrapper.position-relative(v-show="content.cover", :class="{ shadow: !hover }")
      imagec(placeholder, horizontal, :src="content.cover ? content.cover.xsmall : ''")
    pr-wrapper.title(
      :class="{ backgroundTo: hover && background, background: !hover && background }",
      :fs="hover",
      :bg="hover ? 'overlayFrom' : 'darken'",
      bgd="90"
    )
      pr-text(muted)
        moment.small.d-block.mb-2(v-if="content.date", humanize, format="date", :value="content.date")
      pr-text(weight="semibold", v-html="content.title")
      pr-text.mt-1(size="small", muted, v-if="content.subtitle", v-html="content.subtitle")
      action(:data="content", size="small", v-if="hasAction")
</template>

<script>
import action from "./actions.vue"
export default {
  name: "cms-card",
  filters: {
    addPriceUnit: function(value) {
      if (!value) return ""
      value = value.toString()
      return `${value} ${__.device.config("view_currency.view_currency")}`
    }
  },
  components: { action },
  props: ["data", "active", "type", "width"],
  computed: {
    content() {
      return this.data
    },
    background() {
      return this.active
    },
    hover() {
      return this.type === "hover"
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-card {
  display: inline-block;
  vertical-align: top;
}
.title {
  padding: 1.5rem !important;
  white-space: normal !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
}
</style>
